<template>
  <div class="led-container">
    <!--    <svg viewBox="0 0 100 170" preserveAspectRatio="xMidYMid meet"> -->
    <svg viewBox="0 0 195 195" preserveAspectRatio="none" width="100%" height="100%">
      <!-- Fondo azul muy oscuro -->
      <rect width="195" height="195" fill="#0a0e27" />
      
      <!-- Segmentos -->
      <g v-for="(segment, index) in segments" :key="index">
        <!-- Segmento -->
        <rect
          :x="segment.x"
          :y="segment.y"
          :width="segment.width"
          :height="segment.height"
          :fill="isActive(6-index) ? segment.colorOn : segment.colorOff"
          rx="3"
        />
        <!-- Brillo interior (efecto LED encendido) -->
        <rect
          v-if="isActive(6-index)"
          :x="segment.x + 2"
          :y="segment.y + 2"
          :width="segment.width - 4"
          :height="segment.height - 4"
          :fill="segment.colorGlow"
          rx="2"
          opacity="0.4"
        />
      </g>
    </svg>
  </div>
</template>

<script>
export default {
  name: 'LedSegments',
  props: {
    segment: {
      type: Number,
      default: null,
      validator: (value) => value === null || (Number.isInteger(value) && value >= 1 && value <= 6)
    }
  },
  data() {
    return {
      segments: [
        {
          x: 10,
          y: 10,
          width: 175,
          height: 25,
          colorOn: '#00ff44',
          colorOff: '#0a2a08',
          colorGlow: '#ffffff'
        },
        {
          x: 10,
          y: 40,
          width: 175,
          height: 25,
          colorOn: '#11dd55',
          colorOff: '#0d2410',
          colorGlow: '#ffffff'
        },
        {
          x: 10,
          y: 70,
          width: 175,
          height: 25,
          colorOn: '#ffdd22',
          colorOff: '#2a2408',
          colorGlow: '#ffffff'
        },
        {
          x: 10,
          y: 100,
          width: 175,
          height: 25,
          colorOn: '#ffcc11',
          colorOff: '#2a2010',
          colorGlow: '#ffffff'
        },
        {
          x: 10,
          y: 130,
          width: 175,
          height: 25,
          colorOn: '#ff4422',
          colorOff: '#2a0808',
          colorGlow: '#ffffff'
        },
        {
          x: 10,
          y: 160,
          width: 175,
          height: 25,
          colorOn: '#ff2211',
          colorOff: '#1a0408',
          colorGlow: '#ffffff'
        }
      ]
    }
  },
  methods: {
    isActive(segmentNumber) {
      return this.segment === segmentNumber;
    }
  }
}
</script>

<style scoped>
.led-container {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: strech;
  justify-content: strech;
  background: #0a0e27;
  overflow: hidden;
  border-radius: 2px;
}

svg {
  width: 100%;
  height: 100%;
  display: block;
}
</style>
